import React from 'react'
import {
  Root,
  Trigger,
  Portal,
  Content,
  Arrow,
  Provider,
} from '@radix-ui/react-tooltip'
import styled, { keyframes } from 'styled-components'
import Icon from './Icon'

const DEFAULT_DELAY = 100
const ANIMATION_DURATION = 0.2

const showUp = keyframes`
  from {
		opacity: 0;
		transform: scale(0);
	}
	to {
		opacity: 1;
		transform: scale(1);
	}
`

const hideAway = keyframes`
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0);
  }
`

const StyledContent = styled(Content)`
  background-color: rgba(50, 50, 50, 0.95);
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.3);
  padding: 16px;
  font-size: 1.4rem;
  border-radius: 8px;
  line-height: 2.1rem;
  color: white;
  border: none;
  z-index: 10000;
  animation: ${showUp} ${ANIMATION_DURATION}s ease-in-out forwards;
  transform-origin: var(--radix-tooltip-content-transform-origin);
  max-width: 400px;

  &[data-state='closed'] {
    animation: ${hideAway} ${ANIMATION_DURATION}s ease-in-out;
  }
`

const StyledArrow = styled(Arrow)`
  fill: rgba(50, 50, 50, 0.95);
`

const ChildrenWrapper = styled.div`
  cursor: pointer;
  display: flex;
`

const ChildrenCenter = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

// Base tooltip component that handles common functionality
const TooltipBase = ({
  children,
  text,
  down,
  delayDuration = DEFAULT_DELAY,
  tooltipStyle,
}) => (
  <Provider>
    <Root delayDuration={delayDuration}>
      {children}
      {text && <Portal>
        <StyledContent
          style={tooltipStyle}
          side={down ? 'bottom' : 'top'}
          sideOffset={10}
        >
          {text}
          <StyledArrow width={11} height={5} />
        </StyledContent>
      </Portal>}
    </Root>
  </Provider>
)

export const TinyPopTooltip = ({
  children,
  down,
  text,
  delayDuration = DEFAULT_DELAY,
}) => (
  <TooltipBase text={text} down={down} delayDuration={delayDuration}>
    <Trigger asChild>{children}</Trigger>
  </TooltipBase>
)

export const PopTooltip = ({
  children,
  down,
  text,
  delayDuration = DEFAULT_DELAY,
  tooltipStyle,
}) => (
  <ChildrenCenter>
    <TooltipBase
      text={text}
      down={down}
      delayDuration={delayDuration}
      tooltipStyle={tooltipStyle}
    >
      <Trigger asChild>
        <ChildrenWrapper>{children}</ChildrenWrapper>
      </Trigger>
    </TooltipBase>
  </ChildrenCenter>
)

const Tooltip = ({ text, down, delayDuration = DEFAULT_DELAY }) => (
  <TooltipBase text={text} down={down} delayDuration={delayDuration}>
    <Trigger asChild>
      <ChildrenWrapper>
        <Icon size={20} name="IosHelpCircleOutline" style={{ opacity: 0.6 }} />
      </ChildrenWrapper>
    </Trigger>
  </TooltipBase>
)

export default Tooltip
